export const fetchDzi = (url) => {
    fetch(url)
        .then((response) => response.text())
        .then((xmlText) => {
        return xmlText;
    })
        .catch((error) => {
        console.error('Error loading DZI file:', error);
    });
};
export async function fetchDziXML(url) {
    try {
        const response = await fetch(url);
        const xmlText = await response.text();
        return xmlText;
    }
    catch (error) {
        console.error('Error fetching DZI XML:', error);
        throw error;
    }
}
